export default __webpack_public_path__ + "maps-examples-source-custom-raster-thumbnail-960-35d29ddd9b99133b38d50c28907b153e.webp";